import { Dayjs, tzDate } from "@mgdx-libs/dayjs";

export type ParseDateTz = (dateText?: string | Dayjs | Date | null) => Dayjs | null;

function isISOFormat(dateString: string) {
  // 秒省略形(datetime-local 由来の YYYY-MM-DDTHH:mm)も許容する
  const isoFormatPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?(([+-]\d{2}:\d{2})|Z)?$/;
  return isoFormatPattern.test(dateString);
}

function isDateFormat(dateString: string) {
  const dateFormatPattern = /^\d{4}-\d{2}-\d{2}$/;
  return dateFormatPattern.test(dateString);
}

/**
 * 日付文字列や Date / Dayjs を Asia/Tokyo の Dayjs へ変換する。
 * 解釈できない文字列や空値は null を返す。
 */
export const parseDateTz: ParseDateTz = (dateText) => {
  if (dateText == null) return null;

  if (typeof dateText === "string") {
    if (dateText === "") return null;

    if (isISOFormat(dateText)) {
      const date = tzDate(dateText);
      return date.isValid() ? date : null;
    }

    if (isDateFormat(dateText)) {
      const date = tzDate(`${dateText}T00:00:00+09:00`);
      return date.isValid() ? date : null;
    }

    // ISO / 日付形式以外の文字列(RFC 1123 等)もパースを試み、解釈できない場合は null を返す
    const date = tzDate(dateText);
    return date.isValid() ? date : null;
  }

  if (typeof dateText !== "object") return null;

  return tzDate(dateText);
};
